import React from 'react';
import {Link} from 'react-router-dom'
import SmallCommentInput from './SmallCommentInput'
import PostAvatar from '../../Post/PostAvatar'
import ReplyInput from './replyComment';
import {getLabel} from "../../../language";
import defaultAvatar from "../../../images/avatar.svg"
import {message, Popover, Slider} from "antd";
import ImportantImage from "../../../images/important.svg";
import TrustImage from "../../../images/trust.svg";
import PositiveImage from "../../../images/positive.svg";
import RelevantImage from "../../../images/relevant.svg";
import agent from "../../../agent";
import connect from "react-redux/src/components/connect";
import {deleteComments} from "../../../actions/comments"
import { Popconfirm } from 'antd';


const mapStateToProps = (state, ownProps) => {
    return {
        anonymousMode: state.user.anonymousMode,
        currentUser: state.common.currentUser,
    }
}

const mapDispatchToProps = (dispatch) => ({
    onDeleteComments: dispatch(deleteComments),
});

class SmallComment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            replies: [],
            isReply: false,
            showReplies: false,
            Important: null,
            Trust: null,
            Interesting: null,
            Positive: null,
            reaction: [],
            visible: {
                Important: false,
                Trust: false,
                Interesting: false,
                Positive: false,
                reaction: false
            }
        }
    }

    componentWillMount() {
        const {replies} = this.props;
        this.repliesSorting(replies);
    }

    componentWillReceiveProps(nextProps) {
        const {replies} = nextProps;
        this.repliesSorting(replies);
    }

    componentDidMount() {
        if (Array.isArray(this.props.interactions.myInteractions)) {
            this.props.interactions.myInteractions.map((item) => {
                this.setState({
                    [item.interactionType]: item.points
                })
            })
        }
        if (Array.isArray(this.props.abuse.myAbuse)) {
            this.props.abuse.myAbuse.map((item) => {
                if (!this.state.reaction.includes(item)) {
                    this.setState(prevState => ({
                        reaction: [
                            ...prevState.reaction,
                            item.abuseType
                        ]
                    }))
                }
            })
        }
    }

    repliesSorting = (replies) => {
        if (replies && Array.isArray(replies)) {
            const repliesSort = replies.sort((firstComment, secondComment) => {
                return firstComment.dateCreated < secondComment.dateCreated ? -1 : 1
            });
            this.setState({
                replies: repliesSort
            })
        }
    }

    getDisplayNameFromMentions = (userName) => {
        const props = this.props
        if (props.mention) {
            const mentionUser = props.mention.find(res => res.id === userName);
            return mentionUser && mentionUser.display && mentionUser.display
        }
        return userName;
    }

    parseBody = body => {
        var matchedMentions = body.match(/\[(.*?)\]/g);
        let content = body;
        if (matchedMentions && matchedMentions.length > 0) {
            matchedMentions.map(res => {
                const userName = res.replace(/[\[\]']+/g, '');
                const replaceFrom = `@[${userName}](${userName})`;
                const displayName = this.getDisplayNameFromMentions(userName);
                content = content.replace(replaceFrom, `<a href=/@${userName}>${displayName}</a>`);
            })
        }
        content = content.replace(/\n/g, "<br/>");
        content = content.replace(/  /g, "&nbsp;&nbsp;");
        // content = content.replace(/(https?:\/\/[^\s]+)/g, "<a href='$1' target='_blank'>$1 </a>")
        content = content.replace(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g, "<a href='$&' target='_blank'>$& </a>")

        return {__html: content};
    }

    parseBodyForcomment = body => {
        let matchedMentions = body.match(/\B@\w+/g);
        let content = body;
        if (matchedMentions && matchedMentions.length > 0) {
            matchedMentions.map(res => {
                const userName = res.match(/\B@\w+/g).pop().replace('@','');
                const displayName = this.getDisplayNameFromMentions(userName);
                content = content.replace(res, `<a href=/@${userName}>${displayName}</a>`);
            })
        }
        return { __html: content };
    }

    handleReply = (value) => {
        this.setState({
            isReply: value
        })
    };

    getClassName = (value) => {
        let className = "neutral";

        // if (value === 2 || value === 1) {
        //     className = "good"
        // } else if (value === 0) {
        //     className = "neutral"
        // } else if (value === -1 || value === -2) {
        //     className = "bad"
        // }

        return className
    };

    handleDeletePostComment = async (id) => {
        let formData = new FormData();
        let data = {}
        data.EntityId = id
        data.EntityType = "PostComment"
        for (const key in data) {
            formData.append(key, data[key]);
        }
        await agent.DeleteComment.deleteComment(formData).then(res => {
            if(res.statusCode === 200){
                this.props.onDeleteComments(id);
            }
        }).catch(err => console.log('Oh no!', err));
    }

    handleReaction = async (name, post) => {
        if (!this.state.reaction.includes(name)) {
            this.setState(prevState => ({
                reaction: [
                    ...prevState.reaction,
                    name
                ]
            }))
        }
        await agent.Abuse.setAbuse({
            "EntityId": post.id,
            "EntityType": "PostComment",
            "AbuseType": name,
            "AuthorId": post.author.id
        }).then(res => {
            console.log({res})
        }).catch(err => console.log('Oh no!', err));
    };

    onChange = async (key, value) => {
        this.setState({
            [key]: value
        })
    };

    onPopOverClose = async (key, value, comment) => {
        this.setState(prevState => ({
            visible: {
                ...prevState.visible,
                [key]: false
            }
        }))
        const body = {
            EntityId: comment.id,
            EntityType: "PostComment",
            AuthorId: comment.author.id,
            InteractionType: key,
            Points: Number(value)
        };

        await agent.Interactions.setInteraction(body).then(res => {
            console.log({res})
        }).catch(err => console.log('Oh no!', err));
    };

    openPopOver = (key) => {
        this.setState(prevState => ({
            visible: {
                ...prevState.visible,
                [key]: true
            }
        }))
    };

    GetInteractionValue = (name) => {
        return this.props.interactions?.myInteractions.find(item => item.interactionType == name)?.points?.toString()
    }

    handleReportAbuse = () =>{
        message.error(getLabel(338));
    }

    render() {
        const {author, dateCreated, id, anonymous, postId} = this.props;
        const {Important, Trust, Interesting, Positive, showReplies, reaction} = this.state
        const mayReportAbuse = this.props?.currentUser?.user_privilege?.mayReportAbuse

        return (
            <div className="comment-dark">
                <div className="comment-box" data-id={id}>
                    <div className="authorimage">
                        <a className="politician">
                            <PostAvatar userName={author.userName || defaultAvatar} height={32} width={32}
                                        isAnonymous={anonymous}/>
                            <span
                                className={author?.isVerified ? "gender verified" :`${parseInt(author.gender) === 1 && "female "}${parseInt(author.gender) === 2 && "male"}`}/>
                        </a>
                    </div>
                    <div className={`post-comment-box-title${this.props.anonymousMode ? "-dark bgl cw" : ""}`}>
                        <div className="d-flex flex-row">
                            <div>
                                <div className={`author ${this.props.anonymousMode ? "cw" : ""}`}
                                     style={{display: 'inline-block'}}>{anonymous ? <Link to="">{getLabel(284)}</Link> :
                                    <Link
                                        to={`/@${author && author.userName}`}>{author.displayName}, {author.displayLocation}</Link>}</div>
                                <div
                                    className="date m-0 m-b-10">{dateCreated && new Date(dateCreated).toDateString() + " " + new Date(dateCreated).toLocaleTimeString('en-US')}</div>
                            </div>
                            <div className="facebook-reaction col-md-1">
                                {mayReportAbuse ?  <span className="like-btn">
                                            <span
                                                className="like-btn-text">Abuse?</span>
                                                <ul className={`${this.props.anonymousMode ? "reactions-box-dark" : "reactions-box"}`}>
                                                        <span className="reaction reaction-vulgar" onClick={() => {
                                                            this.handleReaction("Vulgar", {id, author})
                                                        }} data-reaction="Vulgar"/>
                                                        <span className="reaction reaction-irrelevant" onClick={() => {
                                                            this.handleReaction("Irrelevant", {id, author})
                                                        }} data-reaction="Irrelevant"/>
                                                        <span className="reaction reaction-pointless" onClick={() => {
                                                            this.handleReaction("Pointless", {id, author})
                                                        }} data-reaction="Pointless"/>

                                                </ul>
                                            </span> : <span className="like-btn-text" onClick={()=>this.handleReportAbuse()}>Abuse?</span>}
                                <div className="like-stat">
                                    <span className="like-emo">{reaction && reaction.map((item) => (
                                        <span className={`like-btn-${item || ""}`}/>))}</span> <span
                                    className="like-details">you</span>
                                </div>
                                <div className="delete-comment">
                                    {
                                        this.props?.currentUser?.roles && this.props?.currentUser?.roles[0] === "Admin" &&
                                        <div style={{ marginLeft: 70, clear: 'both', whiteSpace: 'nowrap' }}>
                                        <Popconfirm placement="bottomLeft" title={getLabel(310)} onConfirm={() => this.handleDeletePostComment(id, postId)} okText="Yes" cancelText="No">
                                        <div style={{display: "flex", alignItems: "center", color:"#43c5e6"}}>
                                        <i className="fa fa-trash"/>
                                        </div>
                                        </Popconfirm>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="preview-link text-wrap" dangerouslySetInnerHTML={this.parseBodyForcomment(this.props.body)}/>
                        <div className="justify-content-between" style={{display: "flex"}}>
                            <div className="buttonlist row pull-right">

                                <div className="dropdown m-b-5">
                                    <Popover visible={this.state.visible.Important}
                                             content={
                                                 <div>
                                                     <h5 className="font-12 font-normal m-0">IMPORTANCE</h5>
                                                     <Slider
                                                         vertical
                                                         min={-2}
                                                         max={2}
                                                         value={Important || 0}
                                                         className="vertical-slider-blue"
                                                         onChange={(value) => this.onChange("Important", value)}
                                                         onAfterChange={(value) => this.onPopOverClose("Important", value, {
                                                             id,
                                                             author
                                                         })}
                                                         tooltipVisible={false}
                                                     />
                                                     <h6 style={{marginTop: 20}}>{Important}</h6>
                                                 </div>
                                             }
                                             trigger="click"
                                    >
                                        <button
                                            type="button"
                                            className="btn btn-icon btn-toolbar dropdown-toggle button-hover"
                                            data-toggle="dropdown"
                                            aria-expanded="true"
                                            onClick={() => this.openPopOver("Important")}
                                        >
                                            <img src={ImportantImage}/>
                                        </button>
                                    </Popover>

                                    <div className="buttonvalue" id="importancevalue">
                                        <span
                                            // className={`post-rating${this.props.anonymousMode ? "-dark" : ""} ${this.getClassName(Important)}`}>{this.GetInteractionValue("Important") || Important?.toString() || "Important"}</span>
                                            className={`post-rating${this.props.anonymousMode ? "-dark" : ""} ${this.getClassName(Important)}`}>Important</span>
                                    </div>
                                </div>

                                <div className="dropdown m-b-5">
                                    <Popover visible={this.state.visible.Trust}
                                             content={
                                                 <div>
                                                     <h5 className="font-12 font-normal m-0">TRUST</h5>
                                                     <Slider
                                                         vertical
                                                         min={-2}
                                                         max={2}
                                                         className="vertical-slider-blue"
                                                         value={Trust || 0}
                                                         onChange={(value) => this.onChange("Trust", value)}
                                                         onAfterChange={(value) => this.onPopOverClose("Trust", value, {
                                                             id,
                                                             author
                                                         })}
                                                         tooltipVisible={false}
                                                     />
                                                     <h6 style={{marginTop: 20}}>{Trust}</h6>
                                                 </div>
                                             }
                                             trigger="click"
                                    >
                                        <button
                                            type="button"
                                            className="btn btn-icon btn-toolbar dropdown-toggle"
                                            data-toggle="dropdown"
                                            aria-expanded="true"
                                            onClick={() => this.openPopOver("Trust")}
                                        >
                                            <img src={TrustImage}/>
                                        </button>
                                    </Popover>

                                    <div className="buttonvalue" id="trustvalue">
                                        <span
                                            // className={`post-rating${this.props.anonymousMode ? "-dark" : ""} ${this.getClassName(Trust)}`}>{this.GetInteractionValue("Trust") || Trust?.toString() || "Trust"}</span>
                                            className={`post-rating${this.props.anonymousMode ? "-dark" : ""} ${this.getClassName(Trust)}`}>Trust</span>
                                    </div>
                                </div>

                                <div className="dropdown m-b-5">
                                    <Popover visible={this.state.visible.Positive}
                                             content={
                                                 <div>
                                                     <h5 className="font-12 font-normal m-0">POSITIVE TONE</h5>
                                                     <Slider
                                                         vertical
                                                         min={-2}
                                                         max={2}
                                                         className="vertical-slider-blue"
                                                         value={Positive || 0}
                                                         onChange={(value) => this.onChange("Positive", value)}
                                                         onAfterChange={(value) => this.onPopOverClose("Positive", value, {
                                                             id,
                                                             author
                                                         })}
                                                         tooltipVisible={false}
                                                     />
                                                     <h6 style={{marginTop: 20}}>{Positive}</h6>
                                                 </div>
                                             }
                                             trigger="click"
                                    >
                                        <button
                                            type="button"
                                            className="btn btn-icon btn-toolbar dropdown-toggle"
                                            data-toggle="dropdown"
                                            aria-expanded="true"
                                            onClick={() => this.openPopOver("Positive")}
                                        >
                                            <img src={PositiveImage}/>
                                        </button>
                                    </Popover>

                                    <div className="buttonvalue" id="positivevalue">
                                        <span
                                            // className={`post-rating${this.props.anonymousMode ? "-dark" : ""} ${this.getClassName(Positive)}`}>{this.GetInteractionValue("Positive") || Positive?.toString() || "Positive"}</span>
                                            className={`post-rating${this.props.anonymousMode ? "-dark" : ""} ${this.getClassName(Positive)}`}>Positive</span>
                                    </div>
                                </div>

                                <div className="dropdown m-b-5">

                                    <Popover visible={this.state.visible.Interesting}
                                             content={
                                                 <div>
                                                     <h5 className="font-12 font-normal m-0">RELEVANCE TO ME</h5>
                                                     <Slider
                                                         vertical
                                                         min={-2}
                                                         max={2}
                                                         className="vertical-slider-blue"
                                                         value={Interesting || 0}
                                                         onChange={(value) => this.onChange("Interesting", value)}
                                                         onAfterChange={(value) => this.onPopOverClose("Interesting", value, {
                                                             id,
                                                             author
                                                         })}
                                                         tooltipVisible={false}
                                                     />
                                                     <h6 style={{marginTop: 20}}>{Interesting}</h6>
                                                 </div>
                                             }
                                             trigger="click"
                                    >
                                        <button
                                            type="button"
                                            className="btn btn-icon btn-toolbar dropdown-toggle"
                                            data-toggle="dropdown"
                                            aria-expanded="true"
                                            onClick={() => this.openPopOver("Interesting")}
                                        >
                                            <img src={RelevantImage}/>
                                        </button>
                                    </Popover>

                                    <div className="buttonvalue" id="relevancevalue">
                                        <span
                                            // className={`post-rating${this.props.anonymousMode ? "-dark" : ""} ${this.getClassName(Interesting)}`}>{this.GetInteractionValue("Interesting") || Interesting?.toString() || "Interesting"}</span>
                                            className={`post-rating${this.props.anonymousMode ? "-dark" : ""} ${this.getClassName(Interesting)}`}>Interesting</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="comment-option">
                    <button onClick={() => {
                        !this.state.showReplies && this.setState(prevState => {
                            return {
                                ...prevState, showReplies: true
                            }
                        })
                    }}>{this.state.replies?.length || 0} Replies
                    </button>
                    <button disabled={this.state.isReply} onClick={() => this.handleReply(true)}>Reply</button>
                </div>
                {this.state.isReply && (
                    <div>
                        <ReplyInput
                            replyComment={true}
                            avatar={this.props.user && this.props.user.avatar ? this.props.user.avatar : null}
                            post={this.props.post}
                            commentId={this.props.id}
                            isAvailableForReply={this.props.isAvailableForReply}
                            replyMyPostsAndComments={this.props.replyMyPostsAndComments}
                            onCancel={this.handleReply}
                        />
                    </div>
                )}

                {/*<div className="text form-group" >{this.props.body}</div>*/}

                <div className="row">
                    <div className="offset-md-1 col-md-11">
                        {showReplies && this.state.replies.length > 0 && this.state.replies.slice(0).map((repComment, index) => {
                            return (
                                <div key={index} className="form-group">
                                    <div className="comment-box">
                                        <div className="authorimage">
                                            <a className="politician">
                                                <PostAvatar userName={repComment.author.userName}/>
                                                <span
                                                    className={repComment.autor?.isVerified ?"gender verified":`${parseInt(repComment.author.gender) === 1 && "female "}${parseInt(repComment.author.gender) === 2 && "male"}`}/>
                                            </a>
                                        </div>
                                        <div
                                            className={`post-comment-box-title${this.props.anonymousMode ? "-dark bgl" : ""}`}>
                                            <div className="d-flex flex-row">
                                                <div>
                                                    <div className="author" style={{display: 'inline-block'}}><Link
                                                        to={`/@${repComment.author && repComment.author.userName}`}>{repComment.author.displayName}, {repComment.author.displayLocation}</Link>{getLabel(165)}
                                                    </div>
                                                    <div
                                                        className="date m-0">{repComment.dateCreated && new Date(repComment.dateCreated).toDateString() + " " + new Date(repComment.dateCreated).toLocaleTimeString('en-US')}</div>
                                                </div>
                                                {/*<div className="facebook-reaction">*/}
                                                {/*<span className="like-btn">*/}
                                                {/*    <span*/}
                                                {/*        className="like-btn-text">Abuse?</span>*/}
                                                {/*        <ul className={`${this.props.anonymousMode ? "reactions-box-dark" : "reactions-box"}`}>*/}
                                                {/*            <span className="reaction reaction-vulgar" onClick={()=>{this.handleReaction("Vulgar", repComment )}} data-reaction="Vulgar"></span>*/}
                                                {/*            <span className="reaction reaction-irrelevant" onClick={()=>{this.handleReaction("Irrelevant", repComment )}} data-reaction="Irrelevant"></span>*/}
                                                {/*            <span className="reaction reaction-pointless" onClick={()=>{this.handleReaction("Pointless", repComment )}} data-reaction="Pointless"></span>*/}
                                                {/*        </ul>*/}
                                                {/*</span>*/}
                                                {/*    <div className="like-stat">*/}
                                                {/*        <span className="like-emo"><span className={`like-btn-${this.state.reaction || ""}`}></span></span> <span className="like-details">you</span>*/}
                                                {/*    </div>*/}
                                                {/*</div>*/}
                                            </div>
                                            <div className='preview-link' dangerouslySetInnerHTML={this.parseBody(repComment.body)}/>
                                            <div className="justify-content-between" style={{display: "flex"}}>
                                                {/*<div className="buttonlist row pull-right">*/}

                                                {/*    <div className="dropdown m-b-5">*/}
                                                {/*        <Popover visible={this.state.reply.visible.Important}*/}
                                                {/*                 content={*/}
                                                {/*                     <div>*/}
                                                {/*                         <h5 className="font-12 font-normal m-0">IMPORTANCE</h5>*/}
                                                {/*                         <Slider*/}
                                                {/*                             vertical*/}
                                                {/*                             min={-2}*/}
                                                {/*                             max={2}*/}
                                                {/*                             value={this.state.reply.Important}*/}
                                                {/*                             className="vertical-slider-blue"*/}
                                                {/*                             onChange={(value) => this.onChange("Important", value)}*/}
                                                {/*                             onAfterChange={(value) => this.onPopOverClose("Important", value)}*/}
                                                {/*                             tooltipVisible={false}*/}
                                                {/*                         />*/}
                                                {/*                         <h6 style={{marginTop: 20}}>{Important}</h6>*/}
                                                {/*                     </div>*/}
                                                {/*                 }*/}
                                                {/*                 trigger="click"*/}
                                                {/*        >*/}
                                                {/*            <button*/}
                                                {/*                type="button"*/}
                                                {/*                className="btn btn-icon btn-toolbar dropdown-toggle button-hover"*/}
                                                {/*                data-toggle="dropdown"*/}
                                                {/*                aria-expanded="true"*/}
                                                {/*                onClick={()=>this.openPopOver("Important")}*/}
                                                {/*            >*/}
                                                {/*                <img src={ImportantImage}/>*/}
                                                {/*            </button>*/}
                                                {/*        </Popover>*/}

                                                {/*        <div className="buttonvalue" id="importancevalue">*/}
                                                {/*            <span className={`post-rating ${this.getClassName(Important)}`}>{Important || "Important"}</span>*/}
                                                {/*        </div>*/}
                                                {/*    </div>*/}

                                                {/*    <div className="dropdown m-b-5">*/}
                                                {/*        <Popover visible={this.state.reply.visible.Trust}*/}
                                                {/*                 content={*/}
                                                {/*                     <div>*/}
                                                {/*                         <h5 className="font-12 font-normal m-0">TRUST</h5>*/}
                                                {/*                         <Slider*/}
                                                {/*                             vertical*/}
                                                {/*                             min={-2}*/}
                                                {/*                             max={2}*/}
                                                {/*                             className="vertical-slider-blue"*/}
                                                {/*                             value={this.state.reply.visible.Trust}*/}
                                                {/*                             onChange={(value) => this.onChange("Trust", value)}*/}
                                                {/*                             onAfterChange={(value) => this.onPopOverClose("Trust", value)}*/}
                                                {/*                             tooltipVisible={false}*/}
                                                {/*                         />*/}
                                                {/*                         <h6 style={{marginTop: 20}}>{Trust}</h6>*/}
                                                {/*                     </div>*/}
                                                {/*                 }*/}
                                                {/*                 trigger="click"*/}
                                                {/*        >*/}
                                                {/*            <button*/}
                                                {/*                type="button"*/}
                                                {/*                className="btn btn-icon btn-toolbar dropdown-toggle"*/}
                                                {/*                data-toggle="dropdown"*/}
                                                {/*                aria-expanded="true"*/}
                                                {/*                onClick={()=>this.openPopOver("Trust")}*/}
                                                {/*            >*/}
                                                {/*                <img src={TrustImage}/>*/}
                                                {/*            </button>*/}
                                                {/*        </Popover>*/}

                                                {/*        <div className="buttonvalue" id="trustvalue">*/}
                                                {/*            <span className={`post-rating ${this.getClassName(Trust)}`}>{Trust || "Trust"}</span>*/}
                                                {/*        </div>*/}
                                                {/*    </div>*/}

                                                {/*    <div className="dropdown m-b-5">*/}
                                                {/*        <Popover visible={this.state.reply.visible.Positive}*/}
                                                {/*                 content={*/}
                                                {/*                     <div>*/}
                                                {/*                         <h5 className="font-12 font-normal m-0">POSITIVE TONE</h5>*/}
                                                {/*                         <Slider*/}
                                                {/*                             vertical*/}
                                                {/*                             min={-2}*/}
                                                {/*                             max={2}*/}
                                                {/*                             className="vertical-slider-blue"*/}
                                                {/*                             value={this.state.reply.visible.Positive}*/}
                                                {/*                             onChange={(value) => this.onChange("Positive", value)}*/}
                                                {/*                             onAfterChange={(value) => this.onPopOverClose("Positive", value)}*/}
                                                {/*                             tooltipVisible={false}*/}
                                                {/*                         />*/}
                                                {/*                         <h6 style={{marginTop: 20}}>{Positive}</h6>*/}
                                                {/*                     </div>*/}
                                                {/*                 }*/}
                                                {/*                 trigger="click"*/}
                                                {/*        >*/}
                                                {/*            <button*/}
                                                {/*                type="button"*/}
                                                {/*                className="btn btn-icon btn-toolbar dropdown-toggle"*/}
                                                {/*                data-toggle="dropdown"*/}
                                                {/*                aria-expanded="true"*/}
                                                {/*                onClick={()=>this.openPopOver("Positive")}*/}
                                                {/*            >*/}
                                                {/*                <img src={PositiveImage}/>*/}
                                                {/*            </button>*/}
                                                {/*        </Popover>*/}

                                                {/*        <div className="buttonvalue" id="positivevalue">*/}
                                                {/*            <span className={`post-rating ${this.getClassName(Positive)}`}>{Positive || "Positive"}</span>*/}
                                                {/*        </div>*/}
                                                {/*    </div>*/}

                                                {/*    <div className="dropdown m-b-5">*/}

                                                {/*        <Popover visible={this.state.reply.visible.Interesting}*/}
                                                {/*                 content={*/}
                                                {/*                     <div>*/}
                                                {/*                         <h5 className="font-12 font-normal m-0">RELEVANCE TO ME</h5>*/}
                                                {/*                         <Slider*/}
                                                {/*                             vertical*/}
                                                {/*                             min={-2}*/}
                                                {/*                             max={2}*/}
                                                {/*                             className="vertical-slider-blue"*/}
                                                {/*                             value={this.state.reply.visible.Interesting}*/}
                                                {/*                             onChange={(value) => this.onChange("Interesting", value)}*/}
                                                {/*                             onAfterChange={(value) => this.onPopOverClose("Interesting", value)}*/}
                                                {/*                             tooltipVisible={false}*/}
                                                {/*                         />*/}
                                                {/*                         <h6 style={{marginTop: 20}}>{Interesting}</h6>*/}
                                                {/*                     </div>*/}
                                                {/*                 }*/}
                                                {/*                 trigger="click"*/}
                                                {/*        >*/}
                                                {/*            <button*/}
                                                {/*                type="button"*/}
                                                {/*                className="btn btn-icon btn-toolbar dropdown-toggle"*/}
                                                {/*                data-toggle="dropdown"*/}
                                                {/*                aria-expanded="true"*/}
                                                {/*                onClick={()=>this.openPopOver("Interesting")}*/}
                                                {/*            >*/}
                                                {/*                <img src={RelevantImage}/>*/}
                                                {/*            </button>*/}
                                                {/*        </Popover>*/}

                                                {/*        <div className="buttonvalue" id="relevancevalue">*/}
                                                {/*            <span className={`post-rating ${this.getClassName(Interesting)}`}>{Interesting || "Interesting"}</span>*/}
                                                {/*        </div>*/}
                                                {/*    </div>*/}
                                                {/*</div>*/}
                                                {repComment.replyMyPostsAndComments === 1 &&
                                                <div style={{
                                                    display: 'inline-block',
                                                    float: 'right',
                                                    color: 'blue',
                                                    marginTop: 20
                                                }}>{getLabel(164)}</div>}
                                            </div>
                                        </div>
                                    </div>
                                    {/*<div className="text form-group" dangerouslySetInnerHTML={this.parseBody(this.props.body)} />*/}

                                </div>
                            )
                        })}
                        {!showReplies && this.state.replies.length > 0 && this.state.replies.reverse().slice(0, 2).map((repComment, index) => {
                            return (
                                <div key={index} className="form-group">
                                    <div className="comment-box">
                                        <div className="authorimage cw">
                                            <a className="politician">
                                                <PostAvatar userName={repComment.author.userName}
                                                            isAnonymous={repComment.anonymous}/>
                                                <span
                                                    className={repComment.author?.isVerified ?"gender verified":`${parseInt(repComment.author.gender) === 1 && "female "}${parseInt(repComment.author.gender) === 2 && "male"}`}/>
                                            </a>
                                        </div>
                                        <div
                                            className={`post-comment-box-title${this.props.anonymousMode ? "-dark bgl" : ""}`}>
                                            <div className="d-flex flex-row">
                                                <div>
                                                    <div className={`author ${this.props.anonymousMode ? "cw" : ""}`}
                                                         style={{display: 'inline-block'}}>{repComment.anonymous ?
                                                        <Link to="">{getLabel(284)}</Link> : <Link
                                                            to={`/@${repComment.author && repComment.author.userName}`}>{repComment.author.displayName}, {repComment.author.displayLocation}</Link>} {getLabel(165)}</div>
                                                    <div
                                                        className="date m-0">{repComment.dateCreated && new Date(repComment.dateCreated).toDateString() + " " + new Date(repComment.dateCreated).toLocaleTimeString('en-US')}</div>
                                                </div>
                                                {/*<div className="facebook-reaction">*/}
                                                {/*<span className="like-btn">*/}
                                                {/*    <span*/}
                                                {/*        className="like-btn-text">Abuse?</span>*/}
                                                {/*        <ul className={`${this.props.anonymousMode ? "reactions-box-dark" : "reactions-box"}`}>*/}
                                                {/*            <span className="reaction reaction-vulgar" onClick={()=>{this.handleReaction("Vulgar", repComment )}} data-reaction="Vulgar"></span>*/}
                                                {/*            <span className="reaction reaction-irrelevant" onClick={()=>{this.handleReaction("Irrelevant", repComment )}} data-reaction="Irrelevant"></span>*/}
                                                {/*            <span className="reaction reaction-pointless" onClick={()=>{this.handleReaction("Pointless", repComment )}} data-reaction="Pointless"></span>*/}
                                                {/*        </ul>*/}
                                                {/*</span>*/}
                                                {/*    <div className="like-stat">*/}
                                                {/*        <span className="like-emo"><span className={`like-btn-${this.state.reaction || ""}`}></span></span> <span className="like-details">you</span>*/}
                                                {/*    </div>*/}
                                                {/*</div>*/}
                                            </div>
                                            <div className='preview-link' dangerouslySetInnerHTML={this.parseBody(repComment.body)}/>
                                            <div className="justify-content-between" style={{display: "flex"}}>
                                                {/*<div className="buttonlist row pull-right">*/}

                                                {/*    <div className="dropdown m-b-5">*/}
                                                {/*        <Popover visible={this.state.reply.visible.Important}*/}
                                                {/*                 content={*/}
                                                {/*                     <div>*/}
                                                {/*                         <h5 className="font-12 font-normal m-0">IMPORTANCE</h5>*/}
                                                {/*                         <Slider*/}
                                                {/*                             vertical*/}
                                                {/*                             min={-2}*/}
                                                {/*                             max={2}*/}
                                                {/*                             value={this.state.reply.Important}*/}
                                                {/*                             className="vertical-slider-blue"*/}
                                                {/*                             onChange={(value) => this.onChange("Important", value)}*/}
                                                {/*                             onAfterChange={(value) => this.onPopOverClose("Important", value)}*/}
                                                {/*                             tooltipVisible={false}*/}
                                                {/*                         />*/}
                                                {/*                         <h6 style={{marginTop: 20}}>{Important}</h6>*/}
                                                {/*                     </div>*/}
                                                {/*                 }*/}
                                                {/*                 trigger="click"*/}
                                                {/*        >*/}
                                                {/*            <button*/}
                                                {/*                type="button"*/}
                                                {/*                className="btn btn-icon btn-toolbar dropdown-toggle button-hover"*/}
                                                {/*                data-toggle="dropdown"*/}
                                                {/*                aria-expanded="true"*/}
                                                {/*                onClick={()=>this.openPopOver("Important")}*/}
                                                {/*            >*/}
                                                {/*                <img src={ImportantImage}/>*/}
                                                {/*            </button>*/}
                                                {/*        </Popover>*/}

                                                {/*        <div className="buttonvalue" id="importancevalue">*/}
                                                {/*            <span className={`post-rating ${this.getClassName(Important)}`}>{Important || "Important"}</span>*/}
                                                {/*        </div>*/}
                                                {/*    </div>*/}

                                                {/*    <div className="dropdown m-b-5">*/}
                                                {/*        <Popover visible={this.state.reply.visible.Trust}*/}
                                                {/*                 content={*/}
                                                {/*                     <div>*/}
                                                {/*                         <h5 className="font-12 font-normal m-0">TRUST</h5>*/}
                                                {/*                         <Slider*/}
                                                {/*                             vertical*/}
                                                {/*                             min={-2}*/}
                                                {/*                             max={2}*/}
                                                {/*                             className="vertical-slider-blue"*/}
                                                {/*                             value={this.state.reply.visible.Trust}*/}
                                                {/*                             onChange={(value) => this.onChange("Trust", value)}*/}
                                                {/*                             onAfterChange={(value) => this.onPopOverClose("Trust", value)}*/}
                                                {/*                             tooltipVisible={false}*/}
                                                {/*                         />*/}
                                                {/*                         <h6 style={{marginTop: 20}}>{Trust}</h6>*/}
                                                {/*                     </div>*/}
                                                {/*                 }*/}
                                                {/*                 trigger="click"*/}
                                                {/*        >*/}
                                                {/*            <button*/}
                                                {/*                type="button"*/}
                                                {/*                className="btn btn-icon btn-toolbar dropdown-toggle"*/}
                                                {/*                data-toggle="dropdown"*/}
                                                {/*                aria-expanded="true"*/}
                                                {/*                onClick={()=>this.openPopOver("Trust")}*/}
                                                {/*            >*/}
                                                {/*                <img src={TrustImage}/>*/}
                                                {/*            </button>*/}
                                                {/*        </Popover>*/}

                                                {/*        <div className="buttonvalue" id="trustvalue">*/}
                                                {/*            <span className={`post-rating ${this.getClassName(Trust)}`}>{Trust || "Trust"}</span>*/}
                                                {/*        </div>*/}
                                                {/*    </div>*/}

                                                {/*    <div className="dropdown m-b-5">*/}
                                                {/*        <Popover visible={this.state.reply.visible.Positive}*/}
                                                {/*                 content={*/}
                                                {/*                     <div>*/}
                                                {/*                         <h5 className="font-12 font-normal m-0">POSITIVE TONE</h5>*/}
                                                {/*                         <Slider*/}
                                                {/*                             vertical*/}
                                                {/*                             min={-2}*/}
                                                {/*                             max={2}*/}
                                                {/*                             className="vertical-slider-blue"*/}
                                                {/*                             value={this.state.reply.visible.Positive}*/}
                                                {/*                             onChange={(value) => this.onChange("Positive", value)}*/}
                                                {/*                             onAfterChange={(value) => this.onPopOverClose("Positive", value)}*/}
                                                {/*                             tooltipVisible={false}*/}
                                                {/*                         />*/}
                                                {/*                         <h6 style={{marginTop: 20}}>{Positive}</h6>*/}
                                                {/*                     </div>*/}
                                                {/*                 }*/}
                                                {/*                 trigger="click"*/}
                                                {/*        >*/}
                                                {/*            <button*/}
                                                {/*                type="button"*/}
                                                {/*                className="btn btn-icon btn-toolbar dropdown-toggle"*/}
                                                {/*                data-toggle="dropdown"*/}
                                                {/*                aria-expanded="true"*/}
                                                {/*                onClick={()=>this.openPopOver("Positive")}*/}
                                                {/*            >*/}
                                                {/*                <img src={PositiveImage}/>*/}
                                                {/*            </button>*/}
                                                {/*        </Popover>*/}

                                                {/*        <div className="buttonvalue" id="positivevalue">*/}
                                                {/*            <span className={`post-rating ${this.getClassName(Positive)}`}>{Positive || "Positive"}</span>*/}
                                                {/*        </div>*/}
                                                {/*    </div>*/}

                                                {/*    <div className="dropdown m-b-5">*/}

                                                {/*        <Popover visible={this.state.reply.visible.Interesting}*/}
                                                {/*                 content={*/}
                                                {/*                     <div>*/}
                                                {/*                         <h5 className="font-12 font-normal m-0">RELEVANCE TO ME</h5>*/}
                                                {/*                         <Slider*/}
                                                {/*                             vertical*/}
                                                {/*                             min={-2}*/}
                                                {/*                             max={2}*/}
                                                {/*                             className="vertical-slider-blue"*/}
                                                {/*                             value={this.state.reply.visible.Interesting}*/}
                                                {/*                             onChange={(value) => this.onChange("Interesting", value)}*/}
                                                {/*                             onAfterChange={(value) => this.onPopOverClose("Interesting", value)}*/}
                                                {/*                             tooltipVisible={false}*/}
                                                {/*                         />*/}
                                                {/*                         <h6 style={{marginTop: 20}}>{Interesting}</h6>*/}
                                                {/*                     </div>*/}
                                                {/*                 }*/}
                                                {/*                 trigger="click"*/}
                                                {/*        >*/}
                                                {/*            <button*/}
                                                {/*                type="button"*/}
                                                {/*                className="btn btn-icon btn-toolbar dropdown-toggle"*/}
                                                {/*                data-toggle="dropdown"*/}
                                                {/*                aria-expanded="true"*/}
                                                {/*                onClick={()=>this.openPopOver("Interesting")}*/}
                                                {/*            >*/}
                                                {/*                <img src={RelevantImage}/>*/}
                                                {/*            </button>*/}
                                                {/*        </Popover>*/}

                                                {/*        <div className="buttonvalue" id="relevancevalue">*/}
                                                {/*            <span className={`post-rating ${this.getClassName(Interesting)}`}>{Interesting || "Interesting"}</span>*/}
                                                {/*        </div>*/}
                                                {/*    </div>*/}
                                                {/*</div>*/}
                                                {repComment.replyMyPostsAndComments === 1 &&
                                                <div style={{
                                                    display: 'inline-block',
                                                    float: 'right',
                                                    color: 'blue',
                                                    marginTop: 20
                                                }}>{getLabel(164)}</div>}
                                            </div>

                                        </div>
                                    </div>
                                    {/*<div className="text form-group" dangerouslySetInnerHTML={this.parseBody(this.props.body)} />*/}

                                </div>
                            )
                        })}
                        {/*{this.state.replies.length > 1 && this.props.post &&*/}
                        {/*<Link to={`posts/${this.props.post.slug}`} className="viewall">{getLabel(207)}</Link>*/}
                        {/*}*/}
                        {/*<SmallCommentInput*/}
                        {/*    replyComment={true}*/}
                        {/*    avatar={this.props.user && this.props.user.avatar ? this.props.user.avatar : null}*/}
                        {/*    post={this.props.post}*/}
                        {/*    commentId={this.props.id}*/}
                        {/*    isAvailableForReply={this.props.isAvailableForReply}*/}
                        {/*    replyMyPostsAndComments = {this.props.replyMyPostsAndComments}*/}
                        {/*/>*/}
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SmallComment)
